import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

function KingdomLeaderboard(props) {
	let history = useHistory();
	const { state } = props.location
	// console.log(state);
	const distData = state[0];
	const k_id = distData.k_id;
	const [myKingdoms, setMyKingdoms] = useState('');
	// console.log(k_id);
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const [error1, setError] = useState(false);
	const [kingdoms, setKingdoms] = useState('');
  	useEffect(() => {
		getLeaderboardData();
	}, []);
	const getLeaderboardData = async () => {
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({user_id:user_id}),
			
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-kingdom-leaderboard', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
		}
		const items = [];
		for (const [index, value] of data.kingdoms.entries()) {
			items.push(
				<div className="row" key={index+"kingdom"}>
					<div className="row kl-ldbrd-data w-100">
						<div class="w-col-2 center pos">{value.pos}</div>
						<div class="w-col-5 kingdom">{value.kingdom_name}</div>
						<div class="w-col-2">{value.played}</div>
						<div class="w-col-1">{value.won}</div>
						<div class="w-col-2 center">{value.nrr.toLocaleString('en-In', {maximumFractionDigits:3, minimumFractionDigits:3})}</div>
					</div>
				</div>
			);
			if(k_id !== '' && k_id === value.k_id){
				const temp = [];
				temp.push(
					<div className="section" key={"my"} id="fixed-footer">
						<div className="row" >
							<div className="row kl-ldbrd-data w-100">
								<div class="w-col-2 center pos">{value.pos}</div>
								<div class="w-col-5 kingdom">{value.kingdom_name}</div>
								<div class="w-col-2">{value.played}</div>
								<div class="w-col-1">{value.won}</div>
								<div class="w-col-2 center">{value.nrr.toLocaleString('en-In', {maximumFractionDigits:3, minimumFractionDigits:3})}</div>
							</div>
						</div>
					</div>
				);
				setMyKingdoms(temp);
			}
		}
		setKingdoms(items);
	};
	return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/kingdom-leaderboard.css'}]
	}/>
	<div className="row no-gutters">
		<div className="application bg-kingdm-ldbrd ">
			<div className="appHeader bg-transparent text-light">
				<div className="left">
					<a className="headerButton goBack"  onClick={() => history.goBack()}>
						<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
					</a>
				</div>
			</div>
			<div className="section">
				<div className="row">
					<div className="kl-top w-100">
						<img src={require("./../images/battle-leaderboard.svg").default} alt="standings" className="img-fluid" />
					</div>
				</div>
				<div className="row">
					<div className="kl-ldbrd-header w-100">
						<div class="w-col-2 center">Position</div>
						<div class="w-col-5">Region Name</div>
						<div class="w-col-2">Played</div>
						<div class="w-col-1">Won</div>
						<div class="w-col-2 center">NRR</div>
					</div>
				</div>
			</div>

			<div className="section scroll">
				<div className='over'>
					{kingdoms}
				</div>
			</div>
			{myKingdoms}
		</div>
		<div className="bg"></div>
	</div>
</>
	);
}

export default KingdomLeaderboard;
